// extracted by mini-css-extract-plugin
export default {"link-secondary":"Footer_link-secondary__m1fx6"};